import { Component } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd, Event } from '@angular/router';
import { routePaths } from './constants';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})

export class AppComponent {
  public isExplictSidebar = false;
  public explictSidebarPages = [`/${routePaths.welcome}`];
  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
  ) {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd && this.explictSidebarPages.indexOf(event.url) !== -1  ) {
        this.isExplictSidebar = true;
      }
    });
  }

  public onActivate(event): void {
    window.scroll(0, 0);
  }
}
